import { DevTool } from '@hookform/devtools';
import { useCallback, useMemo } from 'react';
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { devMode } from 'src/reducers/services/store';

import { Datepicker, SelectControl, Switch } from '../input';

interface IFilterBodyProps<T> {
	filters: T[];
	sanitizeFilterOptionsValues: (param: Object) => Object;
	onApply: (values: FieldValues) => void;
}

const FilterBody = <T,>({ filters, sanitizeFilterOptionsValues, onApply }: IFilterBodyProps<T>) => {
	const { control, resetField, handleSubmit } = useForm<FieldValues>();

	const onSubmit: SubmitHandler<FieldValues> = useCallback(
		(data) => {
			const filtersValues = Object.keys(data).reduce<FieldValues>((acc, key) => {
				if (data[key] !== 'default') {
					acc[key] = data[key];
				}
				return acc;
			}, {});

			const values = sanitizeFilterOptionsValues(filtersValues);

			onApply(values);
		},
		[onApply]
	);

	//TODO: Fix filters types
	const filterInputs = useMemo(() => {
		return filters.map((f) => {
			switch ((f as any)?.type) {
				case 'switch':
					return <Switch key={(f as any)?.name} control={control} {...(f as any)} />;
				case 'select':
					return <SelectControl key={(f as any)?.name} control={control} filtersTitle={true} resetField={resetField} {...(f as any)} />;
				case 'datepicker':
					return (
						<Datepicker
							key={(f as any)?.name}
							control={control}
							portalId="root-portal" // Render it in <body>
							{...(f as any)}
						></Datepicker>
					);
				default:
					console.warn(`Unsupported filter type: ${(f as any)?.type}`);
					return null;
			}
		});
	}, [filters, control, resetField]);

	return (
		<div className="container">
			<div className="row g-5">
				<form id="filterForm" className="max-vh-50 overflow-auto" onSubmit={handleSubmit(onSubmit)}>
					{filterInputs}
				</form>
			</div>
			{devMode && <DevTool control={control} />}
		</div>
	);
};

export default FilterBody;
